import React, { ReactElement } from 'react';
import { ReactComponent as DownloadCtx } from '../../../../assets/images/svg/DownloadCtx.svg';
import '../../reconciliation.less';
import '../../../../index.less';
import { Col, Tag } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import Uploader from './Uploader';
import { DownloadExcel } from '../../../crm/inPatient/service/crmUtils';

const ReconcileNowModal = ({fileListObj: files, setFileListObj}: any): ReactElement => {
  const fileList: UploadFile<any>[] = [];
  const onDelete = (selectedFile: UploadFile, linkedTo: string): any => {
    const selectedIndex = fileList?.findIndex((ele: any): boolean => ele?.uid === selectedFile?.uid);
    if (selectedIndex > -1) {
      fileList?.splice(selectedIndex, 1);
      setFileListObj({ ...files, [linkedTo]: [...fileList] });
    }
  };

  return (
  <div className="flex flex-element flex-col">
    <div className="flex flex-element flex-col">
      <div className="text-primary bold mx-5">
        Download IHX Template
      </div>
      <div className="flex flex-element flex-row items-center reconciliate-modal-card mouse-pointer"
        onClick={(): any => DownloadExcel('Reconciliation_Financial_Record_Template.xlsx', 'Reconciliation_template.xlsx')}>
        <DownloadCtx/>
        <div className="record-heading">
          Financial Statement Template
        </div>
      </div>
    </div>
    <div>
      <div className="text-primary bold mx-5">
        Upload IHX Template
      </div>
      <Uploader files={files} setFileListObj={setFileListObj}/>
      {
        files['FinanceReport']?.length ?
          <div className="docs-section">
            {
              files['FinanceReport']?.map((file: any, index: number): any => (
                <Col key={file?.uid}>
                  <Tag className="mb-sm custom-tag" closable={true} onClose={(): any => onDelete(file, 'FinanceReport')}>
                    {(file?.name || '')}
                  </Tag>
                </Col>
              ))
            }
          </div> : <></>
        }
    </div>
    <div>
      <div className="bold">*Instructions</div>
      <ul>
        <li>
          User must upload the template in the excel format.
        </li>
        <li>
          User must maintain the format of the template
        </li>
        <li>
          User must share the template with no additional rows on top and addition column at the left
        </li>
        <li>
          User must not provide any blank rows or column or cell between the data points in the template
        </li>
      </ul>
    </div>
  </div>);
};
export default ReconcileNowModal;
